import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManageRatings(data = {}) {
  let abortController;
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function postRating(data) {
    if (abortController) abortController.abort();

    abortController = new AbortController();

    return privateFetch.post(`/v1/admin/ratings`, data, {
      signal: abortController.signal,
    });
  }

  function manageQuizQuestion(data = {}) {
    return postRating(data);
  }

  return useMutation(manageQuizQuestion, {
    onSuccess() {},
    onSettled() {
      queryClient.invalidateQueries('topic-details');
      queryClient.invalidateQueries('quiz-questions');
    },
  });
}

export default useManageRatings;
